import React, { useState, useEffect, useContext } from 'react';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import * as storage from '@utils/storage';
import { IsEnglish } from '@utils/language';
import { Company, Worksite } from '@users';
import * as AccessType from '@scripts/AccessTypeMode';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { AppContext } from '@/AppContext';
import { GetWorksiteDescription } from '@utils/accessTypeHelper';
import { IsEmployeeMode, IsSupervisorMode } from '@users';
import { generateToken } from '@actions/authentication';
import { connectApp } from '@actions/login';
import { withCookies } from 'react-cookie';
import styles from '@styles/accesMode.module.css';

const useStyles = makeStyles(theme => ({
    root: {
        width: '95%',
        '& .MuiButtonGroup-root': {
            height: '30px'
        },
    },
    menuEmp: {
        backgroundColor: '#72a95c !important',
        color: '#ffffff',
        textTransform: 'uppercase'
    },
    menuSup: {
        backgroundColor: '#5c7fb9 !important',
        color: '#ffffff',
        textTransform: 'uppercase'
    },
    formControl: {
        '& label.MuiInputLabel-formControl': {
            transform: 'translate(12px, 10px) scale(1)'
        },
        '& label.MuiFormLabel-root.MuiFormLabel-filled': {
            fontSize: '16px !important',
        },
        '& div.MuiInputBase-formControl': {
            height: '35px',
            backgroundColor: '#fff',
            boxShadow: '1px 1px 4px 1px #9f9d9d7a',
            borderRadius: '4px',
        },
        '& div.MuiSelect-select': {
            color: '#5d5d5d'
        },
        margin: theme.spacing(1),
        width: '94%',
        
        "& :before": {
            borderBottom: 'none !important'
        },
        "& :after": {
            borderBottom: 'none !important'
        },
    },
    selectItem: {
        height: 'auto'
    },
    selected: {
        boxShadow: 'inset 0px 2px 10px 7px rgba(0, 0, 0, 0.25) !important'
    },
    hideLabelWorksite: {
        '& label.MuiFormLabel-root.MuiFormLabel-filled': {
            display: 'none'
        }
    },
    supervisorWorksiteLabel: {
        textAlign: 'left',
        fontSize: '13px',
        color: '#f14668',
        marginTop: '10px'
    },
    disableEvents: {
        pointerEvents: 'none'
    },
    disableForm: {
        cursor: 'not-allowed'
    }
}));

function AccessMode(props) {
    const classes = useStyles();
    const [worksites, setWorksites] = useState(storage.getWorksites());
    const [worksite, setWorksite] = useState();
    const [typeMode, setTypeMode] = useState(0);
    const [showLabelWorksite, setShowLabelWorksite] = useState(true);
    const [showSelectWorksite, setShowSelectWorksite] = useState(false);
    const [employeeClicked, setEmployeeClicked] = useState(false);
    const [supervisorClicked, setSupervisorClicked] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isDisabled, setIsDisabled] = useState(props.isDisabled ?? false);
    const [countAccess, setCountAccess] = useState(0);
    const { setDescWorksite } = useContext(AppContext);

    const hasEmpAccess = storage.getHasEmpAccess();
    const hasSupAccess = storage.getHasSupAccess();

    useEffect(() => {
        if (IsSupervisorMode()) {
            setShowLabelWorksite(false);
            setWorksite(`${Company()}|${Worksite()}`);
        }

        if (IsEmployeeMode()) {
            setWorksite(null);
        }

        if (hasEmpAccess) {
            setCountAccess(count => count + 1);
        }

        if (hasSupAccess) {
            setCountAccess(count => count + 1);
        }

        setIsLoaded(true);
    }, [])

    useEffect(() => {
        setShowSelectWorksite((typeMode == AccessType.Supervisor || IsSupervisorMode()) && worksites.length > 1);

        if (typeMode == AccessType.Supervisor  && worksites.length > 1 && IsEmployeeMode()) {
            props.setShowMenu(false);
        } else {
            props.setShowMenu(true);
        }
        
        // If employee mode
        // If we are already in employee mode we do nothing
        if (typeMode == AccessType.Employee && !IsEmployeeMode()) {
            handleAuthentication('', '', AccessType.Employee);
        }
    }, [typeMode])

    useEffect(() => {
        if (supervisorClicked && worksites.length === 1) {
            handleAuthSupervisor(`${worksites[0].company}|${worksites[0].worksite}`);
        }
    }, [supervisorClicked])

    useEffect(() => {
        if (props.changeMode?.forceChangeMode == true ?? false) {
            if (props.changeMode.typeMode === AccessType.Employee) {
                setEmployeeClicked(true);
            } else if (props.changeMode.typeMode === AccessType.Supervisor) {
                setSupervisorClicked(true);
                setIsDisabled(false);
            }
            setTypeMode(props.changeMode.typeMode);
        }
    }, [props.changeMode])

    const handleMode = (value) => {
        setEmployeeClicked(value === AccessType.Employee);
        setSupervisorClicked(value === AccessType.Supervisor);
        setTypeMode(value);
    }

    const onChangeWorksite = (event) => {
        handleAuthSupervisor(event.target.value);
    }

    const handleAuthSupervisor = (companyWorksite) => {
        setWorksite(companyWorksite);
        const company = companyWorksite.split('|')[0];
        const worksite = companyWorksite.split('|')[1];

        const description = GetWorksiteDescription(company, worksite, worksites);

        setDescWorksite(description);
        setShowLabelWorksite(false);
        handleAuthentication(company, worksite, AccessType.Supervisor);
    }

    const handleAuthentication = async (company, worksite, accessType) => {
        props.setIsProcessing(true);
        await generateToken(company, worksite, accessType);
        connectApp(props);
        props.setIsProcessing(false);
    }

    return (
        <div className={isDisabled ? classes.disableForm : ''}>
            <div className={styles.rootAccesMode + ' ' + (isDisabled ? classes.disableEvents : '')}>
                <div className={styles.modeSwitch}>
                    <div className={(!IsEmployeeMode() || supervisorClicked) ? [styles.slider, styles.supervisor].join(' ') : styles.slider} style={{ '--slider-width': countAccess == 1 ? '100%' : '50%' }}></div>
                    {hasEmpAccess &&
                        <button
                            className={((IsEmployeeMode() && !supervisorClicked) || employeeClicked) ? [styles.switchButton, styles.switchActive].join(' ') : styles.switchButton}
                            onClick={() => handleMode(AccessType.Employee)}
                        >
                            {i18next.t('accessType:mode.employee')}
                        </button>
                    }
                    {hasSupAccess &&
                        <button
                            className={(!IsEmployeeMode() || supervisorClicked) ? [styles.switchButton, styles.switchActive].join(' ') : styles.switchButton}
                            onClick={() => handleMode(AccessType.Supervisor)}
                        >
                            {i18next.t('accessType:mode.supervisor')}
                        </button>
                    }
                </div>

                <div className={classes.selectWorksite}>
                    {showSelectWorksite && <FormControl variant="filled" className={classes.formControl + ' ' + (showLabelWorksite == true ? '' : classes.hideLabelWorksite)}>
                        <InputLabel htmlFor="worksite">{i18next.t('accessType:supervisor.title-worksite')}</InputLabel>
                        <Select
                            id="worksite"
                            value={worksite || ''}
                            onChange={onChangeWorksite}
                        >
                            {worksites && worksites.map((obj, index) =>
                                <MenuItem key={index} className={classes.selectItem} value={`${obj.company}|${obj.worksite}`}>{IsEnglish() ?
                                    `${obj.company} - ${obj.companyDescriptionEnglish}, ${obj.worksite} - ${obj.worksiteDescriptionEnglish}` :
                                    `${obj.company} - ${obj.companyDescriptionFrench}, ${obj.worksite} - ${obj.worksiteDescriptionFrench}`}
                                </MenuItem>
                            )}
                        </Select>
                        {IsEmployeeMode() && supervisorClicked &&
                            <span className={classes.supervisorWorksiteLabel}>{i18next.t('accessType:message.worksite-choose')}</span>
                        }
                    </FormControl>}
                </div>
            </div>
        </div>
    )
}

export default withNamespaces(['menu', 'accessType'], { wait: true })(withCookies(AccessMode))